import { useState } from 'react';
import { API_URL } from '../config';
import { authFetch } from '../utils/authFetch';
import { Button } from './ui/button';

export function ReferralLinkButton() {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);

  const gen = async () => {
    try {
      setBusy(true);
      const res = await authFetch(`${API_URL}/referrals/link`, { method: 'POST' });
      if (!res.ok) throw new Error(`Ошибка ${res.status}`);
      const data = await res.json();
      setUrl(data.url);
      await navigator.clipboard.writeText(data.url);
      alert('Ссылка сгенерирована и скопирована в буфер обмена!');
    } catch (e) {
      alert(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <Button onClick={gen} disabled={busy}>
        {busy ? 'Генерирую...' : 'Получить реферальную ссылку'}
      </Button>
      {url && (
        <a href={url} target="_blank" rel="noreferrer" className="text-blue-600 underline">
          открыть
        </a>
      )}
    </div>
  );
}
